import {Col, Descriptions, Row} from "antd";
import React, {useEffect} from "react";
import InfoItem from "./InfoItem/InfoItem";
import Appearance from "./Appearance/Appearance";
import "./DetailExam.scss";
import Injury from "./Injury/Injury";
import Appendage from "./Appendage/Appendage";
import Conjunctiva from "./Conjunctiva/Conjunctiva";
import Sclera from "./Sclera/Sclera";
import Cornea from "./Cornea/Cornea";
import Anterior from "./Anterior/Anterior";
import Pupil from "./Pupil/Pupil";
import Iris from "./Iris/Iris";
import Lens from "./Lens/Lens";
import Extraocular from "./Extraocular/Extraocular";
import Intraocular from "./Intraocular/Intraocular";
import Gonioscopy from "./Gonioscopy/Gonioscopy";
import Fundus from "./Fundus/Fundus";
import {HeaderCustom} from "components/common";
const DetailExam = props => {
  const {data} = props;

  return (
    <div className="detail-exam-print" style={{width: "100%"}}>
      {data["Ghi chú"] && <InfoItem label="Ghi chú" value={data["Ghi chú"]} />}
      {data["Khám tổng quát"] && (
        <InfoItem label="Khám tổng quát" value={data["Khám tổng quát"]} />
      )}
      {data["Mắt độc nhất"] && <InfoItem label="Mắt độc nhất" value="" />}
      {data["Đánh giá lác"] && <InfoItem label="Đánh giá lác" value="" />}
      {(data?.rightJsonValue || data?.leftJsonValue) && (
        <Row>
          <table style={{width: "100%"}}>
            <thead style={{display: "table-header-group"}}>
              <Row gutter={[8, 8]}>
                <Col sm={12} md={12} lg={12} xl={12}>
                  <HeaderCustom title="Mắt phải"></HeaderCustom>
                </Col>
                <Col sm={12} md={12} lg={12} xl={12}>
                  <HeaderCustom title="Mắt trái"></HeaderCustom>
                </Col>
              </Row>
            </thead>
            <Row gutter={[8, 8]}>
              <Col sm={12} md={12} lg={12} xl={12}>
                <Appearance
                  data={data?.rightJsonValue?.APPEARANCE}
                ></Appearance>
                <Injury data={data?.rightJsonValue?.INJURY}></Injury>
                <Appendage data={data?.rightJsonValue?.APPENDAGES}></Appendage>
                <Conjunctiva
                  data={data?.rightJsonValue?.CONJUNCTIVA}
                ></Conjunctiva>
                <Sclera data={data?.rightJsonValue?.SCLERA}></Sclera>
                <Cornea data={data?.rightJsonValue?.CORNEA}></Cornea>
                <Anterior
                  data={data?.rightJsonValue?.ANTERIOR_CHAMBER}
                ></Anterior>
                <Pupil data={data?.rightJsonValue?.PUPIL}></Pupil>
                <Iris data={data?.rightJsonValue?.IRIS}></Iris>

                <Lens data={data?.rightJsonValue?.LENS}></Lens>

                <Extraocular
                  data={data?.rightJsonValue?.EXTRAOCULAR_MOVEMENTS_SQUINT}
                ></Extraocular>
                <Intraocular
                  data={data?.rightJsonValue?.INTRAOCULAR_PRESSURE}
                ></Intraocular>
                <Gonioscopy
                  data={data?.rightJsonValue?.GONIOSCOPY}
                ></Gonioscopy>
                <Fundus data={data?.rightJsonValue?.FUNDUS}></Fundus>
              </Col>
              <Col sm={12} md={12} lg={12} xl={12}>
                <Appearance data={data?.leftJsonValue?.APPEARANCE}></Appearance>
                <Injury data={data?.leftJsonValue?.INJURY}></Injury>
                <Appendage data={data?.leftJsonValue?.APPENDAGES}></Appendage>
                <Conjunctiva
                  data={data?.leftJsonValue?.CONJUNCTIVA}
                ></Conjunctiva>
                <Sclera data={data?.leftJsonValue?.SCLERA}></Sclera>
                <Cornea data={data?.leftJsonValue?.CORNEA}></Cornea>
                <Anterior
                  data={data?.leftJsonValue?.ANTERIOR_CHAMBER}
                ></Anterior>
                <Pupil data={data?.leftJsonValue?.PUPIL}></Pupil>
                <Iris data={data?.leftJsonValue?.IRIS}></Iris>

                <Lens data={data?.leftJsonValue?.LENS}></Lens>

                <Extraocular
                  data={data?.leftJsonValue?.EXTRAOCULAR_MOVEMENTS_SQUINT}
                ></Extraocular>
                <Intraocular
                  data={data?.leftJsonValue?.INTRAOCULAR_PRESSURE}
                ></Intraocular>
                <Gonioscopy data={data?.leftJsonValue?.GONIOSCOPY}></Gonioscopy>
                <Fundus data={data?.leftJsonValue?.FUNDUS}></Fundus>
              </Col>
            </Row>
          </table>
        </Row>
      )}
    </div>
  );
};
export default DetailExam;
